function PivotCorner(props) {
    return null;
}
PivotCorner.symbol = 'PivotCorner';

export { PivotCorner as default };
